module.exports = __webpack_public_path__ + "static/6305-woodrose-46-aeed9d36208f5b5c1e6f855b9d193c47.jpg";